import * as React from 'react'
import { IconButton } from '@components'
import { useAppSelector } from '@core/store'
import type { ContainerHeaderProps } from './Container.types.ts'
import { cn } from '@core/utils'

const ContainerHeader: React.FC<ContainerHeaderProps> = ({
    title,
    buttonProps,
}) => {
    const settings = useAppSelector(slice => slice.baseSlice.settings)

    return (
        <div className="sticky top-0 z-50 bg-semantic-content-brand lg:static lg:z-auto">
            <div
                className={cn(
                    'lg:container lg:h-[224px] lg:pt-8',
                    settings.single_page_display && 'lg:h-[calc(224px-48px)]',
                )}>
                {!settings.single_page_display && (
                    <div className="flex items-center gap-6 p-6 lg:p-0">
                        <IconButton
                            variant="bg-blurred"
                            name="arrow-left"
                            className="bg-tint-white-10 fill-white focus:ring-0"
                            {...buttonProps}
                        />
                        <h2 className="text-display-md-b text-semantic-background-inkInverse lg:text-display-lg-b">
                            {title}
                        </h2>
                    </div>
                )}
            </div>
        </div>
    )
}

export default ContainerHeader
